import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import Breadcrumbs from 'components/Breadcrumbs'
// import APPURL from 'utils/app/urls'

class PanelsDevelopmentMethodology extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage
    this.state = {}
  }

  render() {
    const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : '';
    const imgLink = this.formatMessage(messages.imgLink);
    // const path = this.props.history.location.pathname;
    // const dimensionLink0 = APPURL.getPanelDimensionLink(path, 0);

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <Breadcrumbs responsive={false} />
              <h1 className="ork-u-mb">{this.formatMessage(messages.methodology)}</h1>
            </div>
          </div>
        </div>
        <div className="container-fluid ork-gray-box ork-u-more-legible-text">
          <h2>{this.formatMessage(messages.framework)}</h2>
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.introductionParagraph1) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.introductionParagraph2) }} />
          <p className="ork-u-mt-3 ork-u-mb-3">
            <img src={BASE_URL + imgLink} className="img-responsive" alt="" />
          </p>

          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.level1Paragraph) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.level2Paragraph) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.level3Paragraph) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.level4Paragraph) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dimensionColophonParagraph1) }} />

          <h3 className="ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb">
            <i>{this.formatMessage(messages.geographicalScope)}</i>
          </h3>
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.geographicalScopeParagraph1) }} />
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.geographicalScopeParagraph2) }} />

          <h3 className="ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb">
            <i>{this.formatMessage(messages.temporalScope)}</i>
          </h3>
          <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.temporalScopeParagraph) }} />

          <h3 className="ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb">
            <i>{this.formatMessage(messages.dataSources)}</i>
          </h3>
          <p>{this.formatMessage(messages.dataSourcesParagraph)}</p>
          <ul>
            <li dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dataSourcesItem1) }} />
            <li dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dataSourcesItem2) }} />
            <li dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dataSourcesItem3) }} />
            <li dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dataSourcesItem4) }} />
          </ul>

          <h3 className="ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb">
            <i>{this.formatMessage(messages.temporalSeriesCompletion)}</i>
          </h3>
          <p>{this.formatMessage(messages.temporalSeriesCompletionParagraph)}</p>

          <h3 className="ork-epigraph ork-epigraph--grey ork-u-mt-3 ork-u-mb">
            <i>{this.formatMessage(messages.indicatorCalculation)}</i>
          </h3>
          <p>{this.formatMessage(messages.indicatorCalculationParagraph)}</p>
        </div>
      </React.Fragment>
    )
  }
}

export default injectIntl(PanelsDevelopmentMethodology)



// WEBPACK FOOTER //
// ./src/modules/PanelsDevelopmentMethodology/PanelsDevelopmentMethodology.jsx